import React  from "react";
import StyledHero from "./heroComponents";
import { StaticImage } from "gatsby-plugin-image";
import { ImageHeader, HeaderContainer, Header, Year  } from "./linkTreeComponents";
import Img from "gatsby-image"


const HeroMobile = (props) => {

    return (
        <>
            <HeaderContainer>
                <Header>
                   <ImageHeader>
                         <StaticImage
                                src="../images/logo-blanco.svg"
                                width={80}
                                height={80}
                                quality={95}
                                formats={["AUTO", "WEBP", "AVIF"]}
                                alt={`Dental VIP Plan de ortodoncia ${Year}`}
                                style={{ marginBottom: `-39px` }}/>
                    </ImageHeader>
                </Header>
            </HeaderContainer>

            <div className="captions center">
                <h1 className="bebas">{props.title.text1}</h1>
                <h1 className="bebas" style={{marginTop: "-34px"}}>{props.title.text2}</h1>
            </div>
      
            <div className="slogan-container">
                <div className="slogan">
                    <p className="bebas"><i>{props.slogan}</i></p>
                </div>
            </div>

            <div className="image-container">
                <Img fluid={props.image.childImageSharp.fluid}></Img>
            </div>
        </>
    );
};

export default HeroMobile;